<template>
  <div v-if="loading" class="loading-container mx-auto">
    <Loading text="Loading REKOM Learning Online" />
  </div>
  <router-view v-else :key="$route.fullPath" />
  <FeedbackModal />
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import FeedbackModal from "@/components/FeedbackModal.vue";

export default {
  name: "App",
  components: { FeedbackModal },
  setup() {
    const loading = ref(true);

    const store = useStore();
    const router = useRouter();

    async function loadRequiredData() {
      loading.value = true;

      await store.dispatch("accounts/ensureUserAccounts");
      await store.dispatch("accounts/getUser");
      console.warn("Got user", store.getters["accounts/user"]);

      const userAccount = store.getters["accounts/activeUserAccount"];
      if (userAccount == null && router.currentRoute.value.name !== "invite") {
        router.push({ name: "no-account" });
      }

      loading.value = false;
    }

    onMounted(async () => {
      await loadRequiredData();
    });

    return {
      loading,
    };
  },
};
</script>

<style>
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loading-container {
  padding-top: 80px;
}
</style>